module.exports = __webpack_public_path__ + "img/slice2.faef014f.png";